import { createApiCall } from 'lib/base';

const CREATE_HOME_WIDGET_CALLOUT_CARD = 'CREATE_HOME_WIDGET_CALLOUT_CARD';

const createHomeWidgetCalloutCardApi = createApiCall<{ payload: any }>(
  CREATE_HOME_WIDGET_CALLOUT_CARD,
  ({ payload }) => ({
    endpoint: `api/admin/home-widget-callout-cards`,
    method: 'POST',
    body: payload,
  })
);

export default createHomeWidgetCalloutCardApi;
